export default "__VITE_ASSET__5214c41e__"